<ax-avatar-edit
  [name]="getName()"
  [avatarURL]="form?.value?.value"
  [update]="updateAvatar"
  [canDelete]="form?.value.value"
  [delete]="updateAvatar"
  [type]="isIndividual ? AvatarType.INDIVIDUAL : AvatarType.INDIVIDUAL"
  [readonly]="readonly"
></ax-avatar-edit>
<mat-hint class="hint" align="end">
  {{ hint }}
</mat-hint>
